import { Component, OnInit, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MonthlyDateRangeSelectorComponent } from '../monthly-date-range-selector/monthly-date-range-selector.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-export-date-range-selector',
  templateUrl: './export-date-range-selector.component.html',
  styleUrls: ['./export-date-range-selector.component.css']
})
export class ExportDateRangeSelectorComponent implements OnInit, AfterViewInit {

  dateBoundsSelectionForm: FormGroup;

  @ViewChild(MonthlyDateRangeSelectorComponent) dateRangeSelector: MonthlyDateRangeSelectorComponent;

  constructor(private formBuilder: FormBuilder,
     public dialogRef: MatDialogRef<ExportDateRangeSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
    //Create the date bounds form - this is the formgroup for the first page
    this.dateBoundsSelectionForm = this.formBuilder.group({
    });

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dateBoundsSelectionForm.addControl('dateBoundsSelectionForm', this.dateRangeSelector.dateBoundsSelectionForm);
    });
  }

  okClick(): void {

    var dateBoundsResults:any = this.dateBoundsSelectionForm.getRawValue();

    var result = {
      BeginDate: dateBoundsResults.dateBoundsSelectionForm.BeginDate,
      EndDate: dateBoundsResults.dateBoundsSelectionForm.EndDate,
    };

    this.dialogRef.close(result);
  }
}
